module.exports = __webpack_public_path__ + "img/pic_shipeichanpin@2x.a7194880.png";